import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { trpc } from '../lib/trpc';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export function AdminProtectedRoute({ children }: AdminProtectedRouteProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const verifyQuery = trpc.admin.verify.useQuery(
    { token: localStorage.getItem('adminToken') || '' },
    {
      enabled: !!localStorage.getItem('adminToken'),
      retry: false,
      onSuccess: () => {
        setIsAuthenticated(true);
        setIsLoading(false);
      },
      onError: () => {
        setIsAuthenticated(false);
        setIsLoading(false);
        navigate('/admin/login');
      },
    }
  );

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      setIsLoading(false);
      navigate('/admin/login');
    }
  }, []);

  if (isLoading || verifyQuery.isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated || verifyQuery.isError) {
    return null; // Se redirige automáticamente
  }

  return <>{children}</>;
}
